<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">{{ isEdit ? 'Edit utsav' : 'Add utsav' }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <form [formGroup]="form" class="dialog-form">
    <div class="field-row">
      @if(!isEdit){
      <div class="field">
        <span class="field-label">Utsav</span>
        <select class="text-box-active" formControlName="utsavId" (change)="onMasterChange()">
          <option value="">Pick an utsav</option>
          @for(m of masters; track m.utsavId){ <option [value]="m.utsavId">{{ m.name }} ({{ m.code }})</option> }
        </select>
      </div>
      } @else {
      <div class="field"><span class="field-label">Utsav code</span><input class="text-box-active" formControlName="utsavCode" readonly /></div>
      }
      <div class="field"><span class="field-label">Title</span><input class="text-box-active" formControlName="utsavTitle" /></div>
      <div class="field"><span class="field-label">Abbreviation</span><input class="text-box-active" formControlName="utsavAbbrev" /></div>
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">Year</span><input class="text-box-active" formControlName="utsavYear" /></div>
      <div class="field"><span class="field-label">Location</span><input class="text-box-active" formControlName="utsavLocation" /></div>
      <div class="field"><span class="field-label">Celebration mode</span><input class="text-box-active" formControlName="celebrationMode" /></div>
    </div>

    <div class="field-row">
      <div class="field"><span class="field-label">Utsav start</span><input type="date" class="text-box-active" formControlName="utsavStartDate" /></div>
      <div class="field"><span class="field-label">Utsav end</span><input type="date" class="text-box-active" formControlName="utsavEndDate" /></div>
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">Gen. req start</span><input type="date" class="text-box-active" formControlName="genReqStartDate" /></div>
      <div class="field"><span class="field-label">Gen. req end</span><input type="date" class="text-box-active" formControlName="genReqEndDate" /></div>
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">Worker req start</span><input type="date" class="text-box-active" formControlName="workerReqStartDate" /></div>
      <div class="field"><span class="field-label">Worker req end</span><input type="date" class="text-box-active" formControlName="workerReqEndDate" /></div>
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">Accommodation start</span><input type="date" class="text-box-active" formControlName="accommodationStartDate" /></div>
      <div class="field"><span class="field-label">Accommodation roster</span><input type="date" class="text-box-active" formControlName="accommodationRosterDate" /></div>
    </div>

    <div class="field-row">
      <label class="checkbox-row"><input type="checkbox" formControlName="isExternalHotelInvolved" /><span>External hotel involved</span></label>
      <label class="checkbox-row"><input type="checkbox" formControlName="isPandalInvolved" /><span>Pandal involved</span></label>
    </div>

    <div class="field-row">
      <div class="field"><span class="field-label">Status reason</span><input class="text-box-active" formControlName="statusReason" /></div>
      <div class="field"><span class="field-label">Comments</span><input class="text-box-active" formControlName="comments" /></div>
    </div>

    <div class="field">
      <span class="field-label">Preview image</span>
      <div class="image-actions">
        <button type="button" class="ac-secondary-small-btn" (click)="pickImage()">
          {{ form.get('photoUrl')?.value ? 'Change image' : 'Select image' }}
        </button>
        @if(form.get('photoUrl')?.value){
        <button type="button" class="ac-secondary-small-btn" (click)="clearImage()">Remove</button>
        }
      </div>
      @if(form.get('photoUrl')?.value){
      <img class="preview-img" [src]="form.get('photoUrl')?.value" alt="preview" />
      } @else {
      <span class="hint">Pick one from the media library (Configurations › Media).</span>
      }
    </div>
  </form>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Close</button>
    <button type="button" class="ac-primary-btn" [disabled]="isLoading" (click)="submit()">
      {{ isEdit ? 'Save' : 'Add' }}
    </button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
